<template>
  <transition name="top" appear>
    <q-page-sticky position="top-right" :offset="[18, 18]">
      <q-btn round small outline color="primary" @click="goView" icon="clear">
        <q-tooltip self="center right" anchor="center left" :delay="500">Отменить</q-tooltip>
      </q-btn>
      <q-btn round small color="warning" @click="doSave" icon="done" :disabled="notChanged">
        <q-tooltip self="center right" anchor="center left" :delay="500">Сохранить</q-tooltip>
      </q-btn>
    </q-page-sticky>>
  </transition>
</template>
<style>

</style>

<script>

export default {
  name: 'saveBtn',
  props: {
    notChanged: {
      type: Boolean,
      required: true,
    },
    goView: {
      type: Function,
      required: true,
    },
    doSave: {
      type: Function,
      required: true,
    },
  },
  components: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/save-btn.vue